<template>
    <div class="entity-panel">
        <div class="entity-title">实体管理</div>
        <div class="entity-search">
            <ConditionSearch
                :resData="resData"
                @conditionInputChange="conditionInputChange"
                @showSearchList="showSearchList"
                :hasInput="false"
                :placeholder="placeholder"
                @searchInputChange="conditionInputChange"
            ></ConditionSearch>
        </div>
        <EditTree
            class="trees-container"
            :datas="treeData"
            :editable="true"
            :maxLevel="3"
            :current="currentUrl"
            @nodeSelected="treeSelect"
            @nodeExpanded="treeExpand"
            @nodeOperate="treeOperate"
        />
    </div>
</template>

<script>
import EditTree from "@/views/zhiji/bComponents/trees/EditTree";
import ConditionSearch from "@/views/zhiji/bComponents/inputs/ConditionSearch";
// eslint-disable-next-line no-unused-vars
import { filterTreeData, updataTreeData, getParentTree } from "@/views/zhiji/js/common/util.js";
import { deleteEntityClasses, editEntityClasses } from "../server";
import EntityClassesEdit from "./EntityClassesEdit.vue";

export default {
    name: "EntityTrees",
    props: ["treeData"],
    components: {
        EditTree,
        ConditionSearch,
    },
    data() {
        return {
            resData: [],
            hasInput: false,
            currentUrl: "",
            placeholder: "搜索实体"
        };
    },
    computed: {
        gameId() {
            return this.$store.state.zhiji.gameState.gameId
        }
    },
    created() {
        // this.getClassifyData();
    },
    methods: {
        conditionInputChange(data) {
            let result = getParentTree(this.treeData.children, data.keywords);
            this.currentUrl = result.path;
        },
        showSearchList(data) {
            this.resData = filterTreeData(this.treeData.children, data.searchInfo);
        },
        treeSelect(data) {
            const payload = {
                id: data.id,
                label: data.label
            };
            if (data.isRoot) {
                payload.id = "";
                payload.label = "全部分类";
            }
            this.$emit("changeClassId", payload)
        },
        treeExpand() {},
        treeOperate(data) {
            if (data.opr === "add") {
                // 
                this.$store.dispatch("zhiji/showModal", {
                    type: EntityClassesEdit,
                    data: {
                        type: "add",
                        entityClasses: {},
                        ...data,
                        confirm: () => {
                            this.$emit("change");
                        }
                    }
                });
            }
            if (data.opr === "edit") {
                updataTreeData(this.treeData.children, data.path.split("/"), treeData => {
                    editEntityClasses({
                        gameId: this.gameId,
                        classifyId: treeData.id,
                        classifyName: data.newLabel
                    }).then(() => {
                        this.$emit("change");
                    });
                });
            }

            if (data.opr === "delete") {
                // 删除确认弹窗
                this.$confirm("您确认删除该分类吗？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    updataTreeData(this.treeData.children, data.path.split("/"), treeData => {
                        deleteEntityClasses({ classifyId: treeData.id, gameId: this.gameId }).then(() => {
                            this.$emit("change");
                        });
                    });
                }); 
            }

        }
    }
};

</script>

<style lang="less" scoped>
.entity-panel {
    position: relative;
    width: 272px;
    height: 100%;
    box-sizing: border-box;
    border-right: 1px solid #e3ecf5;
    background: #f2f7fb;
    // overflow-x: hidden;
    // overflow-y: auto;
    .entity-title {
        font-size: 16px;
        font-weight: 600;
        color: #41475e;
        margin: 16px;
    }
    .entity-search {
        margin: 0 10px 10px 16px;
    }
    .el-input {
        margin: 16px 16px 8px 16px;
        width: auto;
        display: flex;
    }
}
</style>
